export default __webpack_public_path__ + "static/media/tip4svg.a6be5bfd.svg";